export const ERROR_KINDS = {
  CONSOLE: 'console',
  UNCAUGHT: 'uncaught-error',
  UNHANDLED_REJECTION: 'unhandled-rejection',
  REACT_CAUGHT: 'react-caught-error',
  REACT_UNCAUGHT: 'react-uncaught-error',
  REACT_RECOVERABLE: 'react-recoverable-error',
} as const;

export type ErrorKind = (typeof ERROR_KINDS)[keyof typeof ERROR_KINDS];

export const MESSAGE_DEDUPE_WINDOW_MS = 1000;

// Rate limit on error reports (mirrors log-shipper.ts): a burst is fine, but a
// crash/retry loop must not flood the parent and the analytics pipeline with
// tens of thousands of identical events.
export const ERROR_BURST_LIMIT = 50;
export const ERROR_SUSTAINED_PER_SECOND = 0.2; // ~12/min once the burst is spent

// Known noise — browser quirks, a11y warnings, and our own telemetry's failures
// — that is not app breakage and must not be reported as a runtime error.
export const NOISE_PATTERNS: RegExp[] = [
  // Benign browser quirk; notorious for flooding error telemetry.
  /ResizeObserver loop/,
  // Cross-origin scripts stripped by the same-origin policy — no actionable detail.
  /^Script error\.?$/,
  // Radix a11y warnings (not crashes); prevented pre-runtime by static analysis.
  /requires a `?\w*Title`?/,
  /Missing `?Description`? or `?aria-describedby/,
  // Failures of the telemetry pipeline itself (BigBrain fetch, log shipping)
  // must not be re-reported as app errors.
  /BigBrainWeb|log-shipper/,
  // ponytail: caught-and-logged @tanstack/router-core preload bug (link hover);
  // remove once template router deps are bumped past the upstream fix.
  /reading '_nonReactive'/,
];
